const Config = {
  'lowRisk': {
    color: '#4DD3AB',
    tip: 'exchange-getRiskConfig-LowRisk',
  },
  'moderateRisk': {
    color: '#F4CE54',
    tip: 'exchange-common-MediumRisk',
  },
  'highRisk': {
    color: '#F56E85',
    tip: 'exchange-common-HighRisk',
  },
  'forcedLiquidation': {
    color: '#F23051',
    tip: 'exchange-getRiskConfig-ForcedLiquidation',
  },
};

export { Config as default };
